export default __webpack_public_path__ + "static/Logo-335be9bfe5210bf0540f422df2679f99.svg";